import { Box, Container, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { designTokens } from "../../../theme/designTokens";
import { aboutCopy } from "../../../theme/homeContent";
import sundeusOffice01 from "../../../assets/about01.png";
import sundeusOffice02 from "../../../assets/about02.png";
import sundeusOffice03 from "../../../assets/about03.png";
import sundeusOffice04 from "../../../assets/sundeus04.png";
import sundeusOffice05 from "../../../assets/sundeus05.jpg";
import sundeusOffice06 from "../../../assets/sundeus06.jpg";


const { colors, borderRadius } = designTokens;

const galleryImages = [sundeusOffice01, sundeusOffice02, sundeusOffice03, sundeusOffice04, sundeusOffice05, sundeusOffice06];

const AboutSection = () => {
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Box sx={{ py: designTokens.spacing.sectionPy, backgroundColor: colors.backgroundAlt }}>
      <Container maxWidth={designTokens.spacing.containerMax}>
        <Typography
          variant="overline"
          sx={{
            color: colors.primary,
            fontWeight: 700,
            letterSpacing: 2,
            display: "block",
            textAlign: "center",
            mb: 4,
          }}
        >
          {aboutCopy.label}
        </Typography>

        <Box sx={{ mb: 6, mx: -2 }}>
          <Slider {...sliderSettings}>
            {galleryImages.map((img, index) => (
              <Box key={index} sx={{ px: 1 }}>
                <Box
                  component="img"
                  src={img}
                  alt={`Team ${index + 1}`}
                  sx={{
                    width: "100%",
                    height: { xs: 180, md: 180 },
                    objectFit: "cover",
                    borderRadius: borderRadius.md,
                  }}
                />
              </Box>
            ))}
          </Slider>
        </Box>

        <Box sx={{ maxWidth: 1100, mx: "auto", textAlign: "center" }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              color: colors.textPrimary,
              fontSize: designTokens.fontSizes.h2,
              mb: 3,
            }}
          >
            Built by Innovators,
            <Box  sx={{ color: colors.primary }}>
              {" "}Driven by Impact.
            </Box>
          </Typography>
          <Typography variant="body1" sx={{ color: colors.textSecondary, lineHeight: 1.8, mb: 5 }}>
            {aboutCopy.body}
          </Typography>

          <Typography variant="h3" sx={{ fontWeight: 700, color: colors.textPrimary, mb: 2 }}>
            {aboutCopy.visionTitle}
          </Typography>
          <Typography variant="body1" sx={{ color: colors.textSecondary, lineHeight: 1.8 }}>
            {aboutCopy.visionBody}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutSection;
